import Utils from 'general/utils/Utils';
import axiosClient from './axiosClient';

const saleApi = {
  // lay danh sach
  getSaleList: (params) => {
    const url = '/sale';
    return axiosClient.get(url, { params: Utils.filterParams(params) });
  },

  // them
  createSale: (params) => {
    const url = '/sale/create';
    return axiosClient.post(url, params);
  },

  // cap nhat don hang
  updateSale: (id, params) => {
    const url = `/sale/${id}`;
    return axiosClient.put(url, params);
  },
};

export default saleApi;
